export default {
  header: {
    title: '宿泊ギフト券注文フォーム',
    alt: 'お申込み'
  },
  itemName: '星野リゾート宿泊ギフト券',
  headerDescription:
    '1枚あたり5万円分の金券として星野リゾートのご宿泊にご利用いただけます。',
  orderCountNotification: '封筒1枚にまとめて発送します',
  validityPeriodNotification:
    '有効期間はご指定いただいた日付より、1年間有効となります',
  addOrder: '注文を新規追加',
  duplicateOrder: 'この注文内容をコピー',
  submit: 'お支払い情報の入力'
};



// WEBPACK FOOTER //
// ./src/i18n/ja/orderAggregators/purchase.js